"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsUsaStateActive = exports.useActiveUSAStates = exports.UsaStatesUtils = exports.DEFAULT_US_STATES_SETTINGS = void 0;
var _usaStates = require("usa-states");
var _lodash = require("lodash");
var _ = require("./");
var DEFAULT_US_STATES_SETTINGS = {
  includeTerritories: true,
  contiguousOnly: false,
  exclude: [],
  ignoreCharacter: ''
};
exports.DEFAULT_US_STATES_SETTINGS = DEFAULT_US_STATES_SETTINGS;
var usStates = new _usaStates.UsaStates(DEFAULT_US_STATES_SETTINGS);

/**
 * example object
 * {
    name: "Alabama",
    abbreviation: "AL",
    territory: false,
    capital: "Montgomery",
    contiguous: true
  }
 */
var UsaStates = usStates.states.filter(function (state) {
  return !state.territory;
});
var getFullStateName = function getFullStateName(abbreviation) {
  var _find;
  return (_find = (0, _lodash.find)(UsaStates, {
    abbreviation: abbreviation
  })) === null || _find === void 0 ? void 0 : _find.name;
};

/**
 * Endpoint to return all active states including where signups are no longer
 * accepted if {@link includeCareSignupFreezed} is passed in.
 */
var useActiveUSAStates = function useActiveUSAStates(options) {
  var _useRequest = (0, _.useRequest)((0, _.getActiveUSAStates)(options === null || options === void 0 ? void 0 : options.includeCareSignupFreezed), {
      ready: options === null || options === void 0 ? void 0 : options.ready
    }),
    _useRequest$data = _useRequest.data,
    activeUSAStates = _useRequest$data === void 0 ? [] : _useRequest$data,
    loading = _useRequest.loading;
  return {
    activeUSAStates: activeUSAStates,
    loading: loading
  };
};

/**
 * Check if a given US state is active via state abbreviation. An active state is
 * one where treatment is available for legacy members in states that have accepted
 * treatment in the past and new members in states accepting new treatment.
 */
exports.useActiveUSAStates = useActiveUSAStates;
var useIsUsaStateActive = function useIsUsaStateActive(stateAbbreviation) {
  if (!stateAbbreviation) {
    return {
      active: false,
      loading: false
    };
  }
  var _useActiveUSAStates = useActiveUSAStates({
      includeCareSignupFreezed: true
    }),
    activeUSAStates = _useActiveUSAStates.activeUSAStates,
    loading = _useActiveUSAStates.loading;
  return {
    active: !!(0, _lodash.includes)(activeUSAStates, stateAbbreviation),
    loading: loading
  };
};
exports.useIsUsaStateActive = useIsUsaStateActive;
var UsaStatesUtils = {
  UsaStates: UsaStates,
  stateAbbreviations: UsaStates.map(function (UsaState) {
    return UsaState.abbreviation;
  }),
  stateFullNames: UsaStates.map(function (UsaState) {
    return UsaState.name;
  }),
  getFullStateName: getFullStateName
};
exports.UsaStatesUtils = UsaStatesUtils;